/**
 * @fileoverview POST handler for the "/companies/:company_id/app_group_permission_sets/duplicate_permission_set" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdAppGroupPermissionSetsDuplicatePermissionSetCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdAppGroupPermissionSetsDuplicatePermissionSetProps,
  CompaniesCompanyIdAppGroupPermissionSetsDuplicatePermissionSetResult,
} from "./types";

export const postCompaniesCompanyIdAppGroupPermissionSetsDuplicatePermissionSet = reactQueryMutationAdapter(
  companiesCompanyIdAppGroupPermissionSetsDuplicatePermissionSetCacheKeys,
  (
    props: PostCompaniesCompanyIdAppGroupPermissionSetsDuplicatePermissionSetProps
  ): Promise<CompaniesCompanyIdAppGroupPermissionSetsDuplicatePermissionSetResult> => {
    return fetch(
      `/companies/${encodeURIComponent(props.companyId)}/app_group_permission_sets/duplicate_permission_set`,
      "POST",
      {
        name: props.name,
        permissions: props.permissions,
        source: props.source,
        source_permission_set_id: props.source_permission_set_id,
      }
    );
  }
);
